import {
  DEFAULT_ICON_COLOR,
  DEFAULT_ICON_SIZE,
} from "@oneleet/config/constants";
import { cn } from "@oneleet/utils";

export function CustomCloseIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className={cn(
        "fill-current",
        DEFAULT_ICON_SIZE,
        DEFAULT_ICON_COLOR,
        className,
      )}
    >
      <path d="M7.99999 7.05732L11.3 3.75732L12.2427 4.69999L8.94266 7.99999L12.2427 11.3L11.3 12.2427L7.99999 8.94266L4.69999 12.2427L3.75732 11.3L7.05732 7.99999L3.75732 4.69999L4.69999 3.75732L7.99999 7.05732Z" />
    </svg>
  );
}
